import {
  EMailingSubcategory,
  EMailingsCategory,
  ETemporaryBlockedTypes,
  EUserCompanyProfileTabs,
} from './definitions';

const subtitle =
  'Ваш аккаунт временно заблокирован до {{date}}. Чтобы активировать аккаунт, обратитесь в службу технической поддержки.';

export default {
  blockedByLicense:
    'Это действие недоступно. При необходимости обратитесь в <0>службу технической поддержки</0>.',
  serviceUnavailable: 'Сервис временно недоступен. Повторите попытку позже',
  tabs: {
    [EUserCompanyProfileTabs.PAYMENT]: 'Оплата',
    [EUserCompanyProfileTabs.LICENSE]: 'Лицензии',
    [EUserCompanyProfileTabs.REQUISITES]: 'Реквизиты',
    [EUserCompanyProfileTabs.PRICING]: 'Тарифы',
    [EUserCompanyProfileTabs.MAILINGS]: 'Уведомления',
  },
  messages: {
    haveExpiredLicense_one:
      'У вас есть неоплаченный счет за лицензию. Лицензия на канал {{channels}} заблокирована. Для возобновления работы необходимо оплатить выставленные счета.',
    haveExpiredLicense_few:
      'У вас есть неоплаченный счет за лицензии. Лицензии на каналы {{channels}} заблокированы. Для возобновления работы необходимо оплатить выставленные счета.',
    haveExpiredLicense_many:
      'У вас есть неоплаченный счет за лицензии. Лицензии на каналы {{channels}} заблокированы. Для возобновления работы необходимо оплатить выставленные счета.',
    haveExpiredBillForLicense_one:
      'У вас есть неоплаченный счет за лицензии. Работа по каналу {{channels}} заблокирована. Для возобновления работы необходимо оплатить выставленные счета.',
    haveExpiredBillForLicense_few:
      'У вас есть неоплаченный счет за лицензии. Работа по каналам {{channels}} заблокирована. Для возобновления работы необходимо оплатить выставленные счета.',
    haveExpiredBillForLicense_many:
      'У вас есть неоплаченный счет за лицензии. Работа по каналам {{channels}} заблокирована. Для возобновления работы необходимо оплатить выставленные счета.',
    haveNotMoney: 'У вас недостаточно средств для продолжения работы в сервисе. {{action}}',
    haveNotPayedBills:
      'У вас есть неоплаченный счет. В случае неоплаты работа в системе может быть ограничена',
    addBalance: 'Пополните баланс.',
    lowBalance:
      'Доступных средств может быть недостаточно для отправки рассылок. Возможно, стоит пополнить баланс.',
    broadcastBlocked: `Ваш доступ к услугам приостановлен до {{date}}.
       До этого момента отправка рассылок и получение сообщений будут недоступны. Все создаваемые рассылки будут сохраняться как черновики.
       Для активации услуг обратитесь в службу технической поддержки.`,
    accessBlocked: `Ваш доступ к услугам приостановлен до {{date}}.
       До этого момента отправка и получение сообщений будут недоступны.
       Для активации услуг обратитесь в службу технической поддержки.`,
  },
  buttons: {
    openDocumentList: 'Открыть список документов',
    contactSupport: 'Обратиться в службу технической поддержки',
  },
  temporaryBlockModal: {
    toProfile: 'В профиль',
    [ETemporaryBlockedTypes.BROADCASTS]: {
      title: 'Вы не можете регистрировать рассылки',
      subtitle,
    },
    [ETemporaryBlockedTypes.TEMPLATES]: {
      title: 'Вы не можете регистрировать шаблон',
      subtitle,
    },
    [ETemporaryBlockedTypes.CHANNELS]: {
      title: 'Вы не можете регистрировать каналы',
      subtitle,
    },
    [ETemporaryBlockedTypes.CASCADES]: {
      title: 'Вы не можете регистрировать каскад',
      subtitle,
    },
    [ETemporaryBlockedTypes.OTHER]: {
      title: 'Ваш аккаунт временно заблокирован',
      subtitle: 'Чтобы активировать аккаунт, обратитесь в службу технической поддержки.',
    },
  },
  mailings: {
    description:
      'Настройте почтовые уведомления, чтобы вовремя получать информацию о событиях в аккаунте',
    table: {
      channel: 'Канал',
      mailings: 'Уведомления о событиях',
      recipient: 'Получатель',
      hide: 'Свернуть',
      showAll_one: 'еще {{count}} получатель',
      showAll_few: 'еще {{count}} получателя',
      showAll_many: 'еще {{count}} получателей',
    },
    settingsModal: {
      recipients: 'Получатели уведомлений',
      mailing: '<0>Уведомление о событии:</0> {{subcategory}}',
      addRecipient: 'Добавить получателя',
      email: 'email-адрес получателя',
      channel: '<0>Канал:</0> {{channelType}}',
      save: 'Сохранить изменения',
      emailAlreadyExist: 'Такой email-адрес уже добавлен в список получателей',
      incorrectEmail: 'Некорректный email-адрес',
    },
    successNotification: 'Получатели уведомлений успешно обновлены',
    cancelModal: {
      title: 'Сохранить изменения?',
      subtitle: 'Вы изменили состав получателей уведомлений',
      cancelButton: 'Не сохранять',
    },
    category: {
      [EMailingsCategory.CHANNELS_EMAIL_NOTIFICATIONS]: {
        title: 'Уведомления о каналах',
        hint: 'Вы можете добавить или удалить получателей уведомлений о событиях в каналах',
        settingsTitle: 'Настроить уведомления о событиях в каналах',
      },
      [EMailingsCategory.TEMPLATES_EMAIL_NOTIFICATIONS]: {
        title: 'Уведомления о шаблонах',
        hint: 'Вы можете добавить или удалить получателей уведомлений о событиях в шаблонах',
        settingsTitle: 'Настроить уведомления о событиях в шаблонах',
      },
      [EMailingsCategory.LICENSE_EMAIL_NOTIFICATIONS]: {
        title: 'Уведомления о лицензиях',
        hint: 'Вы можете добавить или удалить получателей уведомлений о событиях в лицензиях',
        settingsTitle: 'Настроить уведомления о событиях в лицензиях',
      },
      [EMailingsCategory.BALANCE_EMAIL_NOTIFICATIONS]: {
        title: 'Уведомления о балансе',
        hint: 'Вы можете добавить или удалить получателей уведомлений о балансе',
        settingsTitle: 'Настроить уведомления о балансе',
      },
      [EMailingsCategory.PAYKEEPER_EMAIL_NOTIFICATIONS]: {
        title: 'Уведомления об изменениях в балансе через платёжную систему PayKeeper',
        hint: 'Вы можете добавить или удалить получателей уведомлений о событиях, связанных с платёжной системой PayKeeper',
        settingsTitle: 'Настроить уведомления о событиях, связанных с платёжной системой PayKeeper',
      },
      [EMailingsCategory.STRIPE_EMAIL_NOTIFICATIONS]: {
        title: 'Уведомления об автопополнении баланса через платёжную систему Stripe',
        hint: 'Вы можете добавить или удалить получателей уведомлений о событиях, связанных с платёжной системой Stripe',
        settingsTitle: 'Настроить уведомления о событиях, связанных с платёжной системе Stripe',
      },
    },
    subcategory: {
      [EMailingSubcategory.REGISTRATION_OK_NOTIFY_CHANNEL_EMAIL]: 'Регистрация канала',
      [EMailingSubcategory.REGISTRATION_VK_NOTIFY_CHANNEL_EMAIL]: 'Регистрация канала',
      [EMailingSubcategory.REGISTRATION_VIBER_CHANNEL_EMAIL]: 'Регистрация канала',
      [EMailingSubcategory.REGISTRATION_SMS_CHANNEL_EMAIL]: 'Регистрация канала',
      [EMailingSubcategory.REGISTRATION_WHATSAPP_CHANNEL_EMAIL]: 'Регистрация канала',
      [EMailingSubcategory.RESTRICTIONS_WABA_EMAIL]:
        'Нарушения, ограничения, отключения WhatsApp Business аккаунта',
      [EMailingSubcategory.CHANGE_QUALITY_WHATSAPP_CHANNEL_EMAIL]:
        'Изменение качества, лимита, статуса канала',
      [EMailingSubcategory.REGISTRATION_VK_NOTIFY_TEMPLATE_EMAIL]: 'Регистрация шаблона',
      [EMailingSubcategory.REGISTRATION_OK_NOTIFY_TEMPLATE_EMAIL]: 'Регистрация шаблона',
      [EMailingSubcategory.REGISTRATION_SMS_TEMPLATE_EMAIL]: 'Регистрация шаблона',
      [EMailingSubcategory.REGISTRATION_VIBER_TEMPLATE_EMAIL]: 'Регистрация шаблона',
      [EMailingSubcategory.REGISTRATION_WHATSAPP_TEMPLATE_EMAIL]: 'Регистрация шаблона',
      [EMailingSubcategory.CHANGE_WHATSAPP_TEMPLATE_EMAIL]: 'Изменение категории шаблона',
      [EMailingSubcategory.DISABLE_WHATSAPP_TEMPLATE_EMAIL]: 'Отключение и остановка шаблона',
      [EMailingSubcategory.SMS_LICENSE_STATUS_EMAIL]:
        'Активация, пролонгирование, приостановка, блокировка лицензии',
      [EMailingSubcategory.NOT_ENOUGH_FUNDS_FOR_SMS_LICENSE_EMAIL]:
        'Необходимость пополнения баланса для оплаты лицензии',
      [EMailingSubcategory.VIBER_LICENSE_STATUS_EMAIL]:
        'Активация, пролонгирование, приостановка, блокировка лицензии',
      [EMailingSubcategory.NOT_ENOUGH_FUNDS_FOR_VIBER_LICENSE_EMAIL]:
        'Необходимость пополнения баланса для оплаты лицензии',
      [EMailingSubcategory.WHATSAPP_LICENSE_STATUS_EMAIL]:
        'Активация, пролонгирование, приостановка, блокировка лицензии',
      [EMailingSubcategory.NOT_ENOUGH_FUNDS_FOR_WHATSAPP_LICENSE_EMAIL]:
        'Необходимость пополнения баланса для оплаты лицензии',
      [EMailingSubcategory.PAYKEEPER_REFUND_EMAIL]: 'Возврат платежа по карте',
      [EMailingSubcategory.STRIPE_TOP_UP_BALANCE_EMAIL]:
        'Автопополнение баланса через платёжную систему Stripe',
      [EMailingSubcategory.OVERDRAFT_STATUS_EMAIL]: 'Уведомление об изменении овердрафта',
      [EMailingSubcategory.BALANCE_DROPPED_BELOW_THRESHOLD_EMAIL]:
        'Достигнуто минимальное значение баланса',
    },
  },
};
